import type { ClientError } from '@tribeplatform/gql-client/lib'
import {
  Fields,
  MassActionRequest,
  MutationConfirmMassActionRequestArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'

export const useConfirmMassActionRequest = (options?: {
  fields?: Fields.MassActionRequestFields
  useMutationOptions?: UseMutationOptions<
    MassActionRequest,
    ClientError,
    MutationConfirmMassActionRequestArgs
  >
}) => {
  const { useMutationOptions, fields = 'basic' } = options || {}
  const { client } = useTribeClient()

  return useMutation<
    MassActionRequest,
    ClientError,
    MutationConfirmMassActionRequestArgs
  >(
    variables =>
      client.mutation({
        name: 'confirmMassActionRequest',
        args: {
          fields,
          variables,
        },
      }),
    useMutationOptions,
  )
}
